import { FC } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
} from '@chakra-ui/react';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';
import { ConfigTemplateTextarea, PlaneTextInput } from '../../../Forms';
import { EditHookReturnType } from '../../../types';

type Props = EditHookReturnType['form'] & {
  mode: '登録' | '更新';
  handleConfirm: () => void;
  onOpenModalDelete: () => void;
  clawlers: ApiKeyTemplate['clawlers'];
};

export const ApiKeyTemplateRegistrationInputModalView: FC<Props> = ({
  mode,
  register,
  formState,
  handleConfirm,
  onOpenModalDelete,
  clawlers,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">APIキーテンプレートの{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl isRequired isInvalid={!!formState.errors.name}>
          <FormLabel>テンプレート名</FormLabel>
          <PlaneTextInput name="name" register={register} />
          <FormErrorMessage>{formState.errors.name?.message}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={!!formState.errors.template}>
          <FormLabel>テンプレート</FormLabel>
          <ConfigTemplateTextarea
            name="template"
            register={register}
            rows={8}
          />
          <FormErrorMessage>
            {formState.errors.template?.message}
          </FormErrorMessage>
        </FormControl>
        {mode === '更新' && (
          <FormControl>
            <FormLabel>テンプレートを使用しているクローラー一覧</FormLabel>
            <TableContainer
              overflowY="auto"
              maxH="400px"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="md"
            >
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>ID</Th>
                    <Th>クローラー名</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {clawlers && clawlers.length ? (
                    clawlers.map(({ id, name: crawlerName }) => (
                      <Tr key={id}>
                        <Td>{id}</Td>
                        <Td>{crawlerName}</Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan={3}>
                        <Text color="gray.300">クローラーなし</Text>
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </FormControl>
        )}
      </Stack>
    </ModalBody>
    <ModalFooter justifyContent="center" p="40px">
      <Stack alignItems="center" spacing="24px">
        <Button
          width={140}
          colorScheme="blackAlpha"
          onClick={handleConfirm}
          isDisabled={!formState.isValid}
        >
          確認
        </Button>
        {mode === '更新' && (
          <Button
            variant="link"
            colorScheme="blackAlpha"
            onClick={onOpenModalDelete}
          >
            このテンプレートを削除
          </Button>
        )}
      </Stack>
    </ModalFooter>
  </ModalContent>
);
